module.exports = __webpack_public_path__ + "static/parfume_4k-59d7d8c52436e8bfab0c18eaef79555b.jpg";